import { styled } from 'mz-ui-kit'

export const Container = styled('main', {
  position: 'relative',
})
